import { createSlice } from "@reduxjs/toolkit";

export const comparisonSlice = createSlice({
  name: "comparison",
  initialState: {
    timeframe: 2,
    demographic: ["group-k5"],
    region: ["All"],
    topic: -1,
    metric: 1,
  },
  reducers: {
    setComparisonTimeframe(state, action) {
      const { payload } = action;
      state.timeframe = payload;
    },
    setComparisonDemographic(state, action) {
      const { payload } = action;
      state.demographic = payload;
    },
    setComparisonRegion(state, action) {
      const { payload } = action;
      state.region = payload;
    },
    setComparisonTopic(state, action) {
      const { payload } = action;
      state.topic = payload;
    },
    setComparisonMetric(state, action) {
      const { payload } = action;
      state.metric = payload;
    }
  },
});

export const {
  setComparisonTimeframe,
  setComparisonDemographic,
  setComparisonRegion,
  setComparisonTopic,
  setComparisonMetric
} = comparisonSlice.actions;

export const comparisonReducer = comparisonSlice.reducer; 